import React, { createContext } from 'react';
import { useCredentialsForContext } from '../hooks/useCredentials';
import PropTypes from 'prop-types';

export const CredentialsContext = createContext([null, null, null]);

export const Provider = ({ children }) => {
  const credentials = useCredentialsForContext();

  return <CredentialsContext.Provider value={credentials}>{children}</CredentialsContext.Provider>;
};

Provider.propTypes = {
  children: PropTypes.node.isRequired,
};
